import { LinkActionTypes, AddLinks, ModifyLinks, DeleteLinks } from 'Actions/ActionTypes/index';
import { Link, Id } from 'NSwag/ServerClient/Client.nswag';

/**
 * Defines methods that create action objects for Links
 * in the store
 */

export const addLinks = (links: Link[]): AddLinks => ({
    type: LinkActionTypes.AddLinks as LinkActionTypes.AddLinks,
    links
});

export const modifyLinks = (links: Link[]): ModifyLinks => ({
    type: LinkActionTypes.ModifyLinks as LinkActionTypes.ModifyLinks,
    links
});

export const deleteLinks = (ids: Id[]): DeleteLinks => ({
    type: LinkActionTypes.DeleteLinks as LinkActionTypes.DeleteLinks,
    ids
});

export type LinkAction = ReturnType<typeof addLinks | typeof modifyLinks | typeof deleteLinks>